const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1280px",
    height: "202px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-17630,-4261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-on-black",
    serifId: "Logo on black",
    transform: "matrix(1.00594,0,0,1.00739,-105.044,34.2338)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17630.3,
    y: 4195.77,
    width: 1272.44,
    height: 200.519,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.51168,0,0,0.510945,15898.6,4791.24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.701781,0,0,0.701781,583.718,-1268.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4207.63,
    cy: 488.566,
    r: 215.878,
    style: {
      fill: "url(#_Linear1)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.676336,0,0,0.676336,1064.2,-1293.77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3783.51,480C3783.51,321.048 3912.56,192 4071.51,192C4230.46,192 4359.51,321.048 4359.51,480C4359.51,638.952 4230.46,768 4071.51,768L3655.5,768C3596.09,768 3539.12,744.401 3497.11,702.395C3455.11,660.388 3431.51,603.416 3431.51,544.01L3431.51,480L3431.51,544C3431.51,641.137 3510.37,720 3607.51,720C3704.64,720 3783.51,641.137 3783.51,544L3783.51,480Z",
    style: {
      fill: "url(#_Radial2)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.23708,0,0,2.23387,21673.2,3498.01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1653.19,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.668,-0.729C0.668,-0.744 0.673,-0.757 0.683,-0.767C0.693,-0.776 0.705,-0.781 0.72,-0.781C0.735,-0.781 0.747,-0.776 0.756,-0.767C0.766,-0.757 0.771,-0.744 0.771,-0.729L0.771,-0.052C0.771,-0.037 0.766,-0.024 0.756,-0.015C0.747,-0.005 0.735,0 0.72,0C0.705,0 0.693,-0.005 0.683,-0.015C0.673,-0.025 0.668,-0.037 0.668,-0.052L0.668,-0.35L0.204,-0.35L0.204,-0.052C0.204,-0.037 0.199,-0.025 0.19,-0.015C0.18,-0.005 0.167,0 0.152,0C0.137,0 0.125,-0.005 0.115,-0.015C0.105,-0.025 0.1,-0.037 0.1,-0.052L0.1,-0.729C0.1,-0.744 0.105,-0.757 0.115,-0.767C0.125,-0.776 0.137,-0.781 0.152,-0.781C0.167,-0.781 0.18,-0.776 0.19,-0.767C0.199,-0.757 0.204,-0.744 0.204,-0.729L0.204,-0.442L0.668,-0.442L0.668,-0.729Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1575.44,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.338,-0.551C0.391,-0.551 0.438,-0.539 0.48,-0.516C0.521,-0.492 0.554,-0.459 0.578,-0.417C0.601,-0.375 0.613,-0.327 0.613,-0.273C0.613,-0.22 0.601,-0.172 0.578,-0.13C0.555,-0.088 0.522,-0.055 0.481,-0.032C0.439,-0.008 0.391,0.004 0.338,0.004C0.285,0.004 0.237,-0.008 0.195,-0.032C0.153,-0.055 0.12,-0.088 0.097,-0.13C0.074,-0.172 0.062,-0.22 0.062,-0.273C0.062,-0.327 0.074,-0.375 0.097,-0.417C0.12,-0.459 0.153,-0.492 0.195,-0.516C0.237,-0.539 0.285,-0.551 0.338,-0.551ZM0.338,-0.461C0.304,-0.461 0.274,-0.453 0.247,-0.437C0.22,-0.421 0.198,-0.399 0.183,-0.37C0.168,-0.341 0.16,-0.309 0.16,-0.273C0.16,-0.237 0.168,-0.205 0.183,-0.177C0.198,-0.148 0.22,-0.126 0.247,-0.11C0.274,-0.094 0.304,-0.086 0.338,-0.086C0.372,-0.086 0.403,-0.094 0.43,-0.11C0.457,-0.126 0.477,-0.148 0.493,-0.177C0.507,-0.205 0.515,-0.237 0.515,-0.273C0.515,-0.309 0.507,-0.341 0.493,-0.37C0.477,-0.399 0.457,-0.421 0.43,-0.437C0.403,-0.453 0.372,-0.461 0.338,-0.461Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1516.03,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.282,-0.551C0.325,-0.551 0.364,-0.544 0.399,-0.53C0.433,-0.516 0.46,-0.497 0.48,-0.472C0.489,-0.461 0.493,-0.451 0.493,-0.44C0.493,-0.429 0.487,-0.418 0.476,-0.409C0.469,-0.404 0.459,-0.401 0.448,-0.401C0.431,-0.401 0.415,-0.407 0.401,-0.42C0.384,-0.435 0.367,-0.446 0.348,-0.453C0.329,-0.459 0.307,-0.462 0.28,-0.462C0.249,-0.462 0.224,-0.457 0.204,-0.447C0.185,-0.436 0.175,-0.422 0.175,-0.403C0.175,-0.39 0.178,-0.379 0.185,-0.37C0.192,-0.361 0.204,-0.352 0.223,-0.344C0.242,-0.337 0.269,-0.329 0.304,-0.322C0.377,-0.307 0.428,-0.287 0.459,-0.261C0.489,-0.235 0.504,-0.201 0.504,-0.16C0.504,-0.129 0.496,-0.102 0.479,-0.077C0.462,-0.051 0.438,-0.032 0.406,-0.018C0.373,-0.003 0.334,0.004 0.289,0.004C0.244,0.004 0.201,-0.003 0.161,-0.017C0.121,-0.031 0.09,-0.049 0.067,-0.072C0.058,-0.081 0.054,-0.091 0.054,-0.103C0.054,-0.119 0.061,-0.132 0.074,-0.142C0.087,-0.151 0.098,-0.156 0.109,-0.156C0.122,-0.156 0.135,-0.15 0.147,-0.138C0.16,-0.124 0.179,-0.112 0.204,-0.102C0.229,-0.091 0.256,-0.086 0.285,-0.086C0.323,-0.086 0.353,-0.092 0.374,-0.105C0.395,-0.118 0.405,-0.135 0.405,-0.156C0.405,-0.177 0.395,-0.194 0.374,-0.207C0.353,-0.221 0.318,-0.233 0.269,-0.242C0.141,-0.267 0.077,-0.319 0.077,-0.4C0.077,-0.433 0.087,-0.46 0.106,-0.483C0.125,-0.506 0.151,-0.523 0.182,-0.534C0.213,-0.545 0.247,-0.551 0.282,-0.551Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1468.96,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.323,-0.1C0.335,-0.1 0.345,-0.095 0.354,-0.086C0.362,-0.077 0.366,-0.065 0.366,-0.05C0.366,-0.035 0.361,-0.023 0.349,-0.014C0.339,-0.005 0.324,0 0.307,0L0.289,0C0.256,0 0.227,-0.009 0.2,-0.025C0.172,-0.043 0.151,-0.066 0.136,-0.095C0.121,-0.124 0.113,-0.157 0.113,-0.194L0.113,-0.441L0.067,-0.441C0.053,-0.441 0.042,-0.445 0.033,-0.453C0.024,-0.461 0.02,-0.471 0.02,-0.483C0.02,-0.496 0.024,-0.507 0.033,-0.515C0.042,-0.523 0.053,-0.527 0.067,-0.527L0.113,-0.527L0.113,-0.671C0.113,-0.686 0.118,-0.698 0.127,-0.707C0.136,-0.716 0.148,-0.721 0.163,-0.721C0.178,-0.721 0.19,-0.716 0.199,-0.707C0.208,-0.698 0.213,-0.686 0.213,-0.671L0.213,-0.527L0.298,-0.527C0.312,-0.527 0.323,-0.523 0.332,-0.515C0.341,-0.507 0.345,-0.496 0.345,-0.483C0.345,-0.471 0.341,-0.461 0.332,-0.453C0.323,-0.445 0.312,-0.441 0.298,-0.441L0.213,-0.441L0.213,-0.194C0.213,-0.167 0.22,-0.145 0.235,-0.127C0.25,-0.109 0.268,-0.1 0.289,-0.1L0.323,-0.1Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1435.19,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.67,-0.781C0.685,-0.781 0.696,-0.777 0.705,-0.769C0.713,-0.761 0.717,-0.751 0.717,-0.738C0.717,-0.73 0.715,-0.721 0.711,-0.712L0.415,-0.033C0.406,-0.011 0.391,0 0.368,0C0.347,0 0.331,-0.011 0.321,-0.033L0.028,-0.703C0.023,-0.717 0.02,-0.729 0.02,-0.738C0.02,-0.751 0.024,-0.762 0.033,-0.77C0.041,-0.777 0.052,-0.781 0.067,-0.781C0.09,-0.781 0.106,-0.771 0.115,-0.75L0.367,-0.146L0.623,-0.75C0.628,-0.762 0.634,-0.77 0.641,-0.775C0.648,-0.779 0.658,-0.781 0.67,-0.781Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1369.97,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.333,-0.781C0.408,-0.781 0.475,-0.764 0.534,-0.731C0.593,-0.698 0.638,-0.652 0.671,-0.593C0.704,-0.534 0.72,-0.466 0.72,-0.391C0.72,-0.316 0.704,-0.248 0.671,-0.189C0.638,-0.13 0.593,-0.083 0.534,-0.05C0.475,-0.017 0.408,0 0.333,0L0.152,0C0.137,0 0.125,-0.005 0.115,-0.015C0.105,-0.025 0.1,-0.037 0.1,-0.052L0.1,-0.729C0.1,-0.744 0.105,-0.757 0.115,-0.767C0.125,-0.776 0.137,-0.781 0.152,-0.781L0.333,-0.781ZM0.333,-0.092C0.388,-0.092 0.438,-0.105 0.482,-0.13C0.525,-0.155 0.559,-0.191 0.584,-0.236C0.608,-0.282 0.62,-0.334 0.62,-0.391C0.62,-0.448 0.608,-0.5 0.584,-0.545C0.559,-0.59 0.525,-0.626 0.482,-0.651C0.438,-0.676 0.388,-0.689 0.333,-0.689L0.204,-0.689L0.204,-0.092L0.333,-0.092Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(93.5653,0,0,93.5653,-1300.45,393.742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.362,-0.79C0.419,-0.79 0.468,-0.778 0.507,-0.755C0.546,-0.732 0.58,-0.698 0.607,-0.655C0.615,-0.642 0.619,-0.63 0.619,-0.619C0.619,-0.604 0.612,-0.592 0.599,-0.583C0.592,-0.578 0.583,-0.576 0.573,-0.576C0.563,-0.576 0.554,-0.579 0.545,-0.584C0.536,-0.589 0.53,-0.595 0.525,-0.604C0.507,-0.634 0.485,-0.657 0.458,-0.673C0.431,-0.688 0.396,-0.696 0.355,-0.696C0.304,-0.696 0.263,-0.686 0.232,-0.667C0.201,-0.647 0.185,-0.618 0.185,-0.581C0.185,-0.546 0.199,-0.517 0.227,-0.494C0.255,-0.471 0.305,-0.455 0.377,-0.448C0.457,-0.44 0.519,-0.416 0.563,-0.376C0.607,-0.335 0.629,-0.282 0.629,-0.216C0.629,-0.168 0.616,-0.127 0.59,-0.093C0.564,-0.058 0.53,-0.033 0.487,-0.016C0.444,0.001 0.397,0.01 0.348,0.01C0.283,0.01 0.225,-0.005 0.172,-0.034C0.118,-0.063 0.082,-0.102 0.062,-0.149C0.059,-0.157 0.057,-0.164 0.057,-0.169C0.057,-0.179 0.061,-0.188 0.068,-0.196C0.075,-0.203 0.085,-0.208 0.098,-0.211C0.1,-0.212 0.103,-0.212 0.108,-0.212C0.119,-0.212 0.129,-0.209 0.139,-0.203C0.148,-0.196 0.155,-0.188 0.16,-0.177C0.172,-0.151 0.196,-0.129 0.231,-0.111C0.266,-0.093 0.305,-0.084 0.348,-0.084C0.398,-0.084 0.44,-0.096 0.475,-0.118C0.51,-0.141 0.527,-0.173 0.527,-0.213C0.527,-0.251 0.512,-0.283 0.483,-0.311C0.454,-0.338 0.409,-0.354 0.349,-0.36C0.266,-0.368 0.201,-0.392 0.154,-0.433C0.107,-0.473 0.083,-0.523 0.083,-0.584C0.083,-0.627 0.095,-0.664 0.119,-0.695C0.144,-0.726 0.177,-0.749 0.22,-0.765C0.262,-0.782 0.309,-0.79 0.362,-0.79Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(246.718,354.276,-354.276,246.718,4084.27,311.428)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(32,210,242)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(13,188,220)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_Radial2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-608,502.591,-502.591,-608,4263.51,265.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(142,247,249)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "rgb(109,234,247)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "rgb(75,221,245)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(59,215,244)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8fd9c81cc615a4ede2485d5a83312ca.svg";
export { ForwardRef as ReactComponent };